import { Box, BoxProps, ButtonNew, ColorOptions, Icon, ModBox, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { NewTable } from '../../comps/NewTable'
import { initRefundsTitleDataV2WithRb } from '../../data/static/data'
import { useLazyApiData, useStores } from '../../data/store'
import SearchView from '../../nav/NewDashboard/Header/SearchView'
import { getInitRefundCustomColumnWidth } from '../../util/util'

export const InitRefund = ({ onDismiss }: any) => {
  const {
    searchData,
    showSearchResult,
    getTxnRemainingAmtToRefund,
    updateSelectedRefundAmount,
    updateSelectedTxn,
    initiateRefunds,
    getSlectedRRNs,
    searchString,
    selectedRefundAmount,
    updateRefundInvoiceId,
  } = useStores((store) => ({
    searchData: store.transactions.getAllRefundTransactions(),
    showSearchResult: store.settings.metaData.showSearchResult,
    searchString: store.settings.metaData.searchString,
    getTxnRemainingAmtToRefund: store.transactions.getSelectedTxnRemainingAmtToRefund,
    updateSelectedRefundAmount: store.transactions.updateSelectedRefundAmount,
    selectedRefundAmount: store.transactions.getSelectedRefundAmount,
    updateSelectedTxn: store.transactions.updateSelectedTxn,
    getSlectedRRNs: store.transactions.getSlectedRRNs,
    initiateRefunds: store.transactions.initiateRefunds,
    updateRefundInvoiceId: store.transactions.updateRefundInvoiceId,
  }))
  const [initiateRefund, { state }] = useLazyApiData(initiateRefunds)
  const [rowsChecked, setRowsChecked] = useState(-1)
  const [invoiceIdValid, setInvoiceIdValid] = useState<boolean>()
  const [isAmountValid, setisAmountValid] = useState(false)
  const [status, setStatus] = useState('NOT_INITIATED')

  useEffect(() => {
    if (state === 'fulfilled') {
      setStatus('SUCCESS')
    } else if (state === 'rejected') {
      setStatus('FAILED')
    }
  }, [onDismiss, state])
  const onChangeText = (rrnNumber: string, value: string): void => {
    if (rrnNumber === getSlectedRRNs()) {
      const remainingAmount = getTxnRemainingAmtToRefund()
      const amountRegex = /^\d+(\.\d{1,2})?$/
      if (!amountRegex.test('' + value) || +value > +remainingAmount || +value === 0 || isNaN(+value)) {
        setisAmountValid(false)
      } else {
        setisAmountValid(true)
      }
      updateSelectedRefundAmount(rrnNumber, value)
    }
  }

  const handleOnSelect = (isChecked: any, index: any) => {
    setRowsChecked(isChecked ? index : -1)
    updateSelectedTxn(isChecked ? searchData[index]?.rrn : '')
  }

  const initRefund = () => {
    setStatus('IN_PROGRESS')
    const listData = searchData[rowsChecked]
    initiateRefund([initRefundsTitleDataV2WithRb, listData])
  }

  const handleRetry = () => {
    setStatus('RETRYING')
    const listData = searchData[rowsChecked]
    initiateRefund([initRefundsTitleDataV2WithRb, listData])
  }

  const onInvoiceIdChange = (value: string): void => {
    if (isEmpty(value)) {
      setInvoiceIdValid(false)
    } else {
      setInvoiceIdValid(true)
    }
    updateRefundInvoiceId(value)
  }

  const isSodexo = searchData[rowsChecked]?.paymentMode === 'Sodexo'
  const screenW = useWindowDimensions()
  return (
    <Box
      bg={'MODAL_SHADOW'}
      width={'100%'}
      height={'100%'}
      justify={'center'}
      align={'center'}
      position={'absolute'}
      top={0}>
      <Box
        backgroundColor="WHITE"
        width={'70%'}
        height={512}
        borderRadius={8}
        shadowRadius={3}
        shadowColor={'#0000001F' as ColorOptions}
        zIndex={10}>
        <Box ph={24} pt={24} align={'center'} justify={'space-between'} flexDirection={'row'}>
          <Text fontFamily={'jiotype-bold'} fontSize={16} color={'BLACK_21'}>
            Initiate Refund
          </Text>
          <Box onPress={() => onDismiss(state === 'fulfilled')} testID="close" underlayColor={'TRANSPARENT'}>
            <Icon id={'CLOSE'} color={'BLACK_21'} size={20} />
          </Box>
        </Box>
        <ModBox show={status === 'NOT_INITIATED' || status === 'IN_PROGRESS'} flexGrow={1}>
          <Box marginRight={22} ml={16} mt={18} maxWidth={screenW * 0.7 - 42}>
            <SearchView path={'REFUND'} onSearchResultClicked={() => {}} type={'initrefund'} />
          </Box>
          <ModBox
            flexGrow={1}
            justify={'center'}
            ph={20}
            show={showSearchResult && searchData?.length > 0 && searchString?.length > 0}
            marginVertical={8}>
            <NewTable
              data={searchData?.slice(0, 5)}
              rowHeight={50}
              headerHeight={64}
              customWidthFunc={getInitRefundCustomColumnWidth}
              tableWidth={screenW * 0.7 - 42}
              headerRowKeys={initRefundsTitleDataV2WithRb}
              onChangeInput={onChangeText}
              onRowClick={() => null}
              transactionType={1}
              rowsChecked={[rowsChecked]}
              onCheckChange={handleOnSelect}
              onInvoiceChange={onInvoiceIdChange}
            />
          </ModBox>
          <ModBox
            flexGrow={1}
            align={'center'}
            justify={'center'}
            show={!(showSearchResult && searchData?.length > 0 && searchString?.length > 0)}>
            <Icon id={'SETTLEMENTS'} size={32} />
            <Spacer size={12} direction={'vertical'} />
            <Text
              fontFamily={'jiotype-medium'}
              fontSize={12}
              color={'LIGHT_BLACK'}
              textAlign={'center'}
              title={'Search by Merchant Ref No/JioPay Txn ID\nto initiate refunds'}
            />
          </ModBox>
          <Box ph={24} pv={16} align={'flex-end'} borderTopWidth={1} borderTopColor={'BG_PRIMARY_SEPARATOR'}>
            <ButtonNew
              testID="initiateRefundBtn"
              title={'Initiate Refund'}
              type={'primarySmall'}
              borderColor={'transparent'}
              borderRadius={'5px'}
              disabled={rowsChecked < 0 || !isAmountValid || (isSodexo && !invoiceIdValid)}
              isLoading={state === 'pending'}
              shadowType={'shadowPrimary'}
              onPress={initRefund}
              textType={'body12'}
            />
          </Box>
        </ModBox>
        <ModBox show={status === 'SUCCESS'} flexGrow={1} align={'center'} justify={'center'}>
          <Box {...styles.tickMark}>
            <Icon id={'TICKMARK'} color={'#3F8C3A' as ColorOptions} size={27} />
          </Box>
          <Spacer size={24} />
          <Text
            title={'Refund request initiated successfully'}
            fontFamily={'jiotype-bold'}
            color={'BLACK_21'}
            fontSize={14}
            lineHeight={20}
          />
          <Spacer size={12} />
          <Box direction={'row'}>
            <Text fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_75'} title={'Txn Id: '} />
            <Text fontFamily={'jiotype-bold'} fontSize={14} color={'BLACK_21'} title={getSlectedRRNs().toString()} />
          </Box>
          <Spacer size={8} />
          <Box direction={'row'}>
            <Text fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_75'} title={'Refund Amount: '} />
            <Text fontFamily={'jiotype-bold'} fontSize={14} color={'BLACK_21'} title={'₹' + selectedRefundAmount()} />
          </Box>
          <Spacer size={24} />
          <Text fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_75'} lineHeight={22} textAlign={'center'}>
            {
              'The refund will be credited to the source account of the user within 3 - 5 business days,\nYou can track the status of this refund in '
            }
            <Text
              title={'Refund History'}
              fontFamily={'jiotype-medium'}
              fontSize={14}
              color={'BLUE'}
              textDecorationLine={'underline'}
              testID="refund-history"
              onPress={() => onDismiss(state === 'fulfilled')}
            />
          </Text>
          <Spacer size={24} />
          <ButtonNew
            type={'secondarySmall'}
            title={'Done'}
            onPress={() => onDismiss(state === 'fulfilled')}
            borderRadius={4}
            borderColor={'BLUE'}
          />
        </ModBox>
        <ModBox show={status === 'FAILED' || status === 'RETRYING'} flexGrow={1} align={'center'} justify={'center'}>
          <Box {...styles.error}>
            <Icon id={'EXCLAMATION'} color={'WHITE'} size={14} />
          </Box>
          <Spacer size={16} />
          <Text
            title={'Oops…\nRequest failed, please try again…'}
            fontFamily={'jiotype-medium'}
            color={'BLACK_75'}
            fontSize={12}
            lineHeight={20}
            textAlign={'center'}
          />
          <Spacer size={40} />
          <ButtonNew
            type={'secondarySmall'}
            title={'Retry'}
            onPress={handleRetry}
            borderRadius={4}
            borderColor={'BLUE'}
            isLoading={state === 'pending'}
          />
        </ModBox>
      </Box>
    </Box>
  )
}

const styles = {
  tickMark: {
    width: '72px',
    height: '72px',
    borderRadius: 36,
    borderWidth: 1,
    borderColor: '#3F8C3A' as ColorOptions,
    alignItems: 'center',
    zIndex: 10000,
    justifyContent: 'center',
    backgroundColor: '#3F8C3A14' as ColorOptions,
  } as BoxProps,
  error: {
    width: '32px',
    height: '32px',
    borderRadius: 16,
    alignItems: 'center',
    zIndex: 10000,
    justifyContent: 'center',
    backgroundColor: 'ERROR',
  } as BoxProps,
}
